// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f172b681","81":"12674f63","84":"ea728717","297":"066507ec","411":"6f0fe409","449":"2ccf19c9","650":"152c566d","689":"dd282a42","787":"9b509a63","895":"3633a1b3"}[chunkId] + ".chunk.js";
};